import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export default function StickyMobileCTA() {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 480);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="sticky-mobile-cta"
      className={[
        "lg:hidden fixed inset-x-0 bottom-0 z-40 px-4 pb-[max(1rem,env(safe-area-inset-bottom))] pt-3 transition-transform duration-300",
        visible ? "translate-y-0" : "translate-y-[120%]",
      ].join(" ")}
    >
      <div className="glass-light rounded-full border border-neutral-200/80 dark:border-neutral-800 shadow-[0_18px_50px_-15px_rgba(6,95,70,0.45)] flex items-center justify-between gap-3 pl-5 pr-2 py-2">
        <div className="leading-tight">
          <div className="text-[10px] uppercase tracking-[0.22em] font-bold text-emerald-800 dark:text-emerald-400">
            {t("brand.name")}
          </div>
          <div className="text-sm font-semibold text-neutral-900 dark:text-neutral-50">
            {t("cta.stickyTitle")}
          </div>
        </div>
        <a
          href="#download"
          data-testid="sticky-cta-button"
          className="inline-flex items-center gap-1.5 h-11 px-5 rounded-full bg-emerald-800 hover:bg-emerald-900 text-stone-50 font-semibold text-sm transition"
        >
          {t("cta.stickyCta")} <ArrowRight className="h-4 w-4" />
        </a>
      </div>
    </div>
  );
}
